import { queryOptions } from '@tanstack/react-query';
import api from '../api';
import {
  ConsentResponseSchema,
  Consent,
  ConsentTemplate,
  ConsentFormStatus,
  GetConsentFormTemplatesResponseSchema,
  ConsentFormTemplateItem,
  SingleConsentFormTemplateResponseSchema,
} from '@/api/schema/consent';

export type { ConsentFormStatus, ConsentTemplate, Consent, ConsentFormTemplateItem };

export function getConsentFormsQueryOptions(subjectId: string) {
  return queryOptions({
    queryKey: [ 'consent-forms', subjectId ],
    queryFn: async () => {
      const response = await api.get(`subjects/${subjectId}/consent-forms`);
      return ConsentResponseSchema.parse(await response.json());
    },
  });
}

export function getConsentFormTemplatesQueryOptions() {
  return queryOptions({
    queryKey: [ 'consent-templates' ],
    queryFn: async () => {
      const response = await api.get('consent/templates');
      return GetConsentFormTemplatesResponseSchema.parse(await response.json());
    },
  });
}

export function getConsentFormTemplateQueryOptions(templateId: string) {
  return queryOptions({
    queryKey: [ 'consent-template', templateId ],
    queryFn: async () => {
      const response = await api.get(`consent/templates/${templateId}`);
      return SingleConsentFormTemplateResponseSchema.parse(await response.json());
    },
  });
}
